<script setup lang="ts">
const jobsFetch = useJobs()

const { pending, data: jobs } = await useAsyncData('jobs', async () =>jobsFetch.fetch())
</script>

<template>
  <div v-if="jobs && !pending">
    <CareersSection 
      id="jobs"
      :title="$t('careers.jobs.title')"
      :eyebrow="$t('careers.jobs.eyebrow')"
      :intro="$t('careers.jobs.description')"
      class="scroll-mt-24"
    >
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-8">
        <CareersJob
          v-for="item of jobs"
          :key="item.title + item.career_level + item.position_type"
          :title="item.title"
          :position-type="item.position_type"
          :level="item.career_level"
          :icon="item.icon.url"
          :location="item.location"
          :job="item"
          :slug="item.slug"
        />
      </div>
    </CareersSection>
  </div>
</template>
